import { ChevronUp } from 'lucide-react';
import { useScrollToTop } from '@/hooks/useScrollToTop';
import { Button } from './Button';
import { Tooltip } from './Tooltip';

export interface ScrollToTopButtonProps {
  threshold?: number;
  className?: string;
  tooltipContent?: string;
}

export function ScrollToTopButton({
  threshold = 300,
  className,
  tooltipContent = 'Scroll to top',
}: ScrollToTopButtonProps) {
  const { scrollToTop, isVisible } = useScrollToTop(threshold);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={className ?? 'fixed bottom-6 right-6 z-50'}>
      <Tooltip content={tooltipContent} position="left">
        <Button
          onClick={scrollToTop}
          variant="ghost"
          size="sm"
          className="aspect-square h-12 w-12 !rounded-full bg-gray-50 !p-0 text-gray-900 shadow-lg ring-1 ring-gray-200 transition-all duration-200 hover:bg-gray-100 dark:bg-dark-950 dark:text-white dark:ring-dark-700 dark:hover:bg-dark-900"
          aria-label={tooltipContent}
        >
          <ChevronUp className="h-5 w-5" />
        </Button>
      </Tooltip>
    </div>
  );
}
